import { Button, Link as UiLink } from "@aws-amplify/ui-react"
import { I18n } from "aws-amplify/utils"
import { Link as ReactRouterLink } from "react-router-dom"

interface CancelButtonProps {
  href: string
  title: string
  isDisabled: boolean
}
function CancelButton({ title, href, isDisabled }: CancelButtonProps) {
  return (
    <UiLink to={href} as={ReactRouterLink}>
      <Button variation="link" isDisabled={isDisabled} size="small">
        {I18n.get(title)}
      </Button>
    </UiLink>
  )
}

export { CancelButton }
